module.exports = __webpack_public_path__ + "img/nothing.2fa2944c.svg";